import { Expose } from "class-transformer";

export class CreateExpenseTypeDto {
  @Expose()
  name: string;

  @Expose()
  accountingAccountId?: string;
}
